import React from "react";
import { ZERO_VALUE, ONE_VALUE } from "@utils/constants";
import { FIRST_INDEX, SECOND_INDEX, MAX_ROW_ID, ZINDEX } from "./constants";
import { FormatWithCommas } from "@helpers/helpers";
import clsx from "clsx";

// Function to generate columns with translation
export const getColumnsConfig = (translate) => [
  {
    accessorKey: "ReconciliationStreamName",
    header: translate("in-transit-list.columns.ReconciliationStreamName"),
    canFilter: true,
    isMultiple: true,
    sortable: true,
    size: 230,
    alignment: "left",
    processFilterValue: (value, row) => {
      return row.ReconciliationStreamTag;
    },
    processFilterKey: (value, row) => {
      return "ReconciliationStreamTag";
    },
    filterType: "checkbox",
    operator: "EQ",
  },
  {
    accessorKey: "AreaName",
    header: translate("in-transit-list.columns.AreaName"),
    processFilterValue: (value, row) => {
      return row.AreaId.toString();
    },
    processFilterKey: (value, row) => {
      return "AreaId";
    },
    size: 150,
    canFilter: true,
    isMultiple: true,
    sortable: true,
    alignment: "left",
    filterType: "checkbox",
    operator: "EQ",
  },
  {
    accessorKey: "OutletName",
    header: translate("in-transit-list.columns.OutletName"),
    processFilterValue: (value, row) => {
      return row.OutletId.toString();
    },
    processFilterKey: (value, row) => {
      return "OutletId";
    },
    size: 150,
    canFilter: true,
    isMultiple: false,
    sortable: true,
    alignment: "left",
    filterType: "string",
    operator: "EQ",
  },
  {
    accessorKey: "TransactionTerminalCode",
    header: translate("in-transit-list.columns.TransactionTerminalCode"),
    processFilterValue: (value, row) => {
      return row.TransactionTerminalCode;
    },
    processFilterKey: (value, row) => {
      return "TransactionTerminalCode";
    },
    size: 150,
    canFilter: true,
    sortable: true,
    filterType: "string",
    operator: "EQ",
  },
  {
    accessorKey: "RecordReference",
    header: translate("in-transit-list.columns.RecordReference"),
    size: 180,
    sortable: true,
    canPin: false,
    canFilter: true,
    filterType: "string",
    operator: "EQ",
  },
  {
    accessorKey: "RecordDate",
    header: translate("in-transit-list.columns.RecordDate"),
    size: 150,
    sortable: true,
    canPin: false,
    canFilter: true,
    filterType: "date",
  },
  {
    accessorKey: "RecordType",
    header: translate("in-transit-list.columns.RecordType"),
    size: 120,
    sortable: true,
    canPin: false,
    canFilter: false,
  },
  {
    accessorKey: "Attributes",
    header: translate("in-transit-list.columns.Attributes"),
    sortable: false,
    size: 180,
    displayInPopup: true,
    filterCheck: (value) => !!value.length,
    // Cell is handled by AttributesCell component
    cellComponent: "AttributesCell",
    // popupContent is handled separately
    popupCellDisplay: (value) => {
      return (
        <div className="relative text-primary-400 font-semibold">
          {value && value.length}
        </div>
      );
    },
  },
  {
    accessorKey: "PaymentMethod",
    header: translate("in-transit-list.columns.PaymentMethod"),
    size: 145,
    sortable: false,
    canPin: true,
    canFilter: false,
  },
  {
    accessorKey: "Amount",
    header: translate("in-transit-list.columns.Amount"),
    canFilter: true,
    filterCheck: (value) => value > ZERO_VALUE,
    isMultiple: false,
    size: 150,
    processFilterValue: (value, row) => {
      return row.Amount.toString();
    },
    // Cell is handled by AmountCell component
    cellComponent: "AmountCell",
    filterType: "amount",
    operator: "EQ",
  },
  {
    accessorKey: "BusinessDay",
    header: translate("in-transit-list.columns.BusinessDay"),
    size: 150,
    sortable: true,
    canPin: false,
    canFilter: true,
    filterType: "date",
    // Cell is handled by BusinessDayCell component
    cellComponent: "BusinessDayCell",
  },
  {
    accessorKey: "InTransitDeadline",
    header: translate("in-transit-list.columns.InTransitDeadline"),
    size: 130,
    sortable: true,
    canPin: false,
    canFilter: false,
    // Cell is handled by InTransitDeadlineCell component
    cellComponent: "InTransitDeadlineCell",
  },
  {
    accessorKey: "NumberOfAttempts",
    header: translate("in-transit-list.columns.NumberOfAttempts"),
    size: 130,
    cellAction: (value, context) => {
      window.location.href = `/in-transit-details?id=${context.row.original.PromotedRecordId}`;
    },
    cellActionCheck: (value) => value > ZERO_VALUE,
  },
  {
    accessorKey: "PendingRecord",
    header: translate("in-transit-list.columns.PendingRecord"),
    size: 250,
    cellAction: (value, context) => {
      window.location.href = `/in-transit-details?id=${context.row.original.PromotedRecordId}`;
    },
    // Cell is handled by PendingRecordCell component
    cellComponent: "PendingRecordCell",
    truncate: true,
    cellActionCheck: (value, context) =>
      context.row.original.NumberOfAttempts > ZERO_VALUE,
  },
];
